import { apiRequest } from './api';
import { Delivery, DeliveryRequest } from '../types/delivery';

export const deliveryService = {
  // Get all deliveries
  getAllDeliveries: async (): Promise<Delivery[]> => {
    return await apiRequest<Delivery[]>('/deliveries');
  },

  // Get delivery by ID
  getDeliveryById: async (id: number): Promise<Delivery> => {
    return await apiRequest<Delivery>(`/deliveries/${id}`);
  },

  // Get default delivery
  getDefaultDelivery: async (): Promise<Delivery> => {
    return await apiRequest<Delivery>('/deliveries/default');
  },

  // Create new delivery
  createDelivery: async (delivery: DeliveryRequest): Promise<Delivery> => {
    return await apiRequest<Delivery>('/deliveries/create', {
      method: 'POST',
      body: JSON.stringify(delivery)
    });
  },

  // Update existing delivery
  updateDelivery: async (id: number, delivery: DeliveryRequest): Promise<Delivery> => {
    return await apiRequest<Delivery>(`/deliveries/${id}`, {
      method: 'PUT',
      body: JSON.stringify(delivery)
    });
  },

  // Delete delivery
  deleteDelivery: async (id: number): Promise<void> => {
    return await apiRequest<void>(`/deliveries/${id}`, {
      method: 'DELETE'
    });
  }
}; 